import Home from '@/view/Home'
import Login from '@/view/Login'
import Configparam from '@/view/Base/Configparam'
import Loanproduct from '@/view/Base/loanproduct/index.vue'
import Salesplatform from '@/view/Base/Salesplatform/index.vue'
import Coreenterprise from '@/view/Base/Coreenterprise/index.vue'
import Filestoragemode from '@/view/Base/Filestoragemode/index.vue'
import Smstemplate from '@/view/Base/Smstemplate/index.vue'
import Servicechargeallocation from '@/view/Base/Servicechargeallocation/index.vue'
import customerManager from '@/view/Base/customerManager/index.vue'
import incomingWhitelist from '@/view/Base/incomingWhitelist/index.vue'
import feeRule from '@/view/Base/feeRule/index.vue'
import feeRuleDetail from '@/view/Base/feeRule/detail.vue'

export default [
    {path: '/home', component: Home, meta: '首页'},
    {path: '/login', component: Login, meta: '登录'},
    {path: '/logistics/login', component: Login, meta: '登录'},
    {path: '/base/configparam', component: Configparam, meta: '参数配置'},
    {path: '/base/loanproduct', component: Loanproduct, meta: '贷款产品'},
    {path: '/base/salesplatform', component: Salesplatform, meta: '销售平台'},
    {path: '/base/servicechargeallocation', component: Servicechargeallocation, meta: '服务费'},
    {path: '/base/coreenterprise', component: Coreenterprise, meta: '核心企业'},
    {path: '/base/smstemplate', component: Smstemplate, meta: '短信模版'},
    {path: '/base/filestoragemode', component: Filestoragemode, meta: '文件存储方式'},
    {path: '/base/customerManager', component: customerManager, meta: '客户经理管理'},
    {path: '/base/incomingWhitelist', component: incomingWhitelist, meta: '来账白名单'},
    {path: '/base/feeRule', component: feeRule, meta: '手续费规则'},
    {path: '/base/feeRuleDetail', component: feeRuleDetail, meta: '手续费规则详情'},
]
